import { ThemeProvider } from "styled-components";
import Navigation from "./components/navigation/Navigation";
import Cookie from "./components/cookie/Cookie";
import Styles from "./components/styles/Styles";
import { AppProvider } from "./context/AppContext";
import AppRoutes from "./routes/Routes";
import { theme } from "./styles/theme";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AppProvider>
        <Styles />
        <Navigation />
        <AppRoutes />
        <Cookie />
      </AppProvider>
    </ThemeProvider>
  );
}

export default App;
